// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"5b2bdfca","395":"b5320c14","626":"2c89be1b","889":"eef03c8a","898":"9ac30169","978":"9ac30169"}[chunkId] + ".chunk.css";
};